var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4H11V3.9C10.946 2.28233 9.61855 0.999101 7.99998 1C6.3814 0.999101 5.05393 2.28233 4.99998 3.9V4H2.99998C2.50292 4 2.09998 4.40294 2.09998 4.9C2.09998 5.39706 2.50292 5.8 2.99998 5.8C2.99211 5.86644 2.99211 5.93357 2.99998 6L3.43998 13.26C3.53801 14.2511 4.37406 15.0048 5.36998 15H10.64C11.6513 14.9922 12.487 14.2088 12.56 13.2L13 6C13.0049 5.94678 13.0049 5.89322 13 5.84C13.5081 5.84 13.92 5.4281 13.92 4.92C13.92 4.4119 13.5081 4 13 4ZM6.79998 3.9C6.81295 3.5949 6.94674 3.30749 7.17185 3.10114C7.39696 2.89479 7.6949 2.78645 7.99998 2.8C8.30505 2.78645 8.60299 2.89479 8.8281 3.10114C9.05321 3.30749 9.187 3.5949 9.19998 3.9V4H6.79998V3.9ZM11.1994 5.85L11.2 5.84H11.21C11.21 5.83 11.23 5.85 11.23 5.85H11.1994ZM11.1994 5.85H4.79998L5.24998 13.09C5.25519 13.1523 5.30742 13.2002 5.36998 13.2H10.63C10.6942 13.1952 10.7452 13.1442 10.75 13.08L11.1994 5.85Z",
    fill: "#2A6EBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c8b4e2412e5665752d0ebc468bf583ed.svg";
export { ForwardRef as ReactComponent };